import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { FormContainerCP } from '@/features/contas-pagar/page/forms/FormContainerCP';
import { StringToIdpkSchema } from '@/std/schema';

const RouteContasPagarParamsSchema = z.discriminatedUnion('action', [
    z.object({
        action: z.literal('cadastrar'),
        idpk: z.undefined().optional(),
    }),
    z.object({
        action: z.enum(['editar', 'clonar', 'visualizar']),
        idpk: StringToIdpkSchema,
    }),
]);

export type RouteContasPagarParams = z.infer<typeof RouteContasPagarParamsSchema>;

export const Route = createFileRoute('/a/contas-pagar/$action/{-$idpk}')({
    component: Component,
    params: {
        parse: (params) => {
            const result = RouteContasPagarParamsSchema.safeParse(params);

            return result.success ? result.data : false;
        },
    },
});

function Component() {
    const params = Route.useParams();

    return <FormContainerCP {...params} />;
}
